import { render, staticRenderFns } from "./SimpleFlexColumn.vue?vue&type=template&id=2229dcba&"
import script from "./SimpleFlexColumn.vue?vue&type=script&lang=js&"
export * from "./SimpleFlexColumn.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFlexColumn.vue?vue&type=style&index=0&id=2229dcba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports